import React, { useEffect, useState } from "react";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Rating from "@mui/material/Rating";
import Box from "@mui/material/Box";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import StarIcon from "@mui/icons-material/Star";
import CircularProgress from "@mui/material/CircularProgress";

import {
  getAllTemplateDetails,
  getAllFeedbacksCategory,
  getAllFeedbackQuestionOptions,
  saveFeedbackAnswer,
} from "./feedbackAssessmentService";
import { questionService } from "../../../../service/assessment/questionService";

import ContentWrapper from "../../../../components/common/ContentWrapper";
import Card from "../../../../components/common/Card";
import { CardBody, CardHeader, CardTitle } from "react-bootstrap";
import { useHistory } from "react-router-dom";

import "./FeedbackAssessment.css";

function FeedbackAssessment({ onClose, assessmentID ,candidate_id}) {
 
  const history = useHistory();

  const [templateData, setTemplateData] = useState(null);
  const [feedbackCategory, setFeedbackCategory] = useState([]);
  const [questionOptions, setQuestionOptions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [languageId, setLanguageId] = useState(1);
  const [userId, setUserId] = useState(0);
  const [loading, setLoading] = useState(false);
  const [showThankyouPage, setThankyouPage] = useState(false);
  const [showFeedbackForm, setShowFeedbackForm] = useState(false);

  const [questionCount, setQuestionCount] = useState(0);
  const [answeredCount, setAnsweredCount] = useState(0);
  const [examStartTime, setExamStartTime] = useState(null);
  const [examFinishTime, setExamFinishTime] = useState(null);
  const [rawExamStartTime, setRawExamStartTime] = useState(null);
  const [rawExamFinishTime, setRawExamFinishTime] = useState(null);

  const [formData, setFormData] = useState({
    assessment_title: "",
    subject: "",
  });

  // const candidate_id = sessionStorage.getItem("candidate_id");
 

  useEffect(() => {
    async function fetchData() {
      try {
        const [res1, res2, res3, res4, res5] = await Promise.all([
          getAllTemplateDetails(),
          getAllFeedbacksCategory(),
          getAllFeedbackQuestionOptions(),
          questionService.getAssessmentQuestions(assessmentID),
          questionService.getAssessmentAnswers(candidate_id, assessmentID),
        ]);

        const language_id = sessionStorage.getItem("studentMedium");
        const user_id = sessionStorage.getItem("user_id");

        setLanguageId(language_id);
        setUserId(user_id);

        const selectedTemplate =
          res1.data.find((template) => template.language_id == language_id) ||
          null;

        setTemplateData(selectedTemplate);
        setFeedbackCategory(res2.data || []);
        setQuestionOptions(res3.data || []);

        const parsedQuestions = JSON.parse(res4.data.examQuestions);
        setQuestionCount(parsedQuestions.questions.length || 0);
        setAnsweredCount(res5.data.answers || 0);

        setExamStartTime(formatToLocalTime(res5.data.candidate_grade_report_details.attempt_start_time));
        setExamFinishTime(formatToLocalTime(res5.data.candidate_grade_report_details.attempt_end_time));

        setFormData((prev) => ({
          ...prev,
          assessment_title: res4.data.assessment_details.title || res5.data.candidateInfo.assessment_title,
          subject: res4.data.assessment_details.subject,
          time_duration: res4.data.assessment_details.time_duration,
        }));


      } catch (err) {
        console.error("Error fetching feedback data:", err);
      }
    }

    fetchData();
  }, [assessmentID]);

const formatToLocalTime = (utcDateStr) => {
   if (!utcDateStr) return "Unlimited";

  const date = new Date(utcDateStr);

  // Add 5 hours 30 minutes → 5.5 * 60 * 60 * 1000 ms
  const colomboTime = new Date(date.getTime() + 5.5 * 60 * 60 * 1000);

  // Format nicely
  return colomboTime.toLocaleString("en-GB", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
};

const calculateDuration = (startUtc, endUtc) => {
  if (!startUtc || !endUtc) return "N/A";

  const start = new Date(startUtc);
  const end = new Date(endUtc);

  const diffMs = Math.max(0, end - start); // in milliseconds

  const hours = Math.floor(diffMs / 3600000);
  const minutes = Math.floor((diffMs % 3600000) / 60000);
  const seconds = Math.floor((diffMs % 60000) / 1000);

  return `${hours} hr ${minutes} min ${seconds} sec`;
};

  const getCategoryById = (id) =>
    feedbackCategory.find((cat) => cat.fb_qus_cat_id === id)?.name;

  const handleAnswerChange = (qusId, value) => {
    setAnswers((prev) => ({ ...prev, [qusId]: value }));
  };

  const handleCheckboxChange = (qusId, optionId) => {
    const prevSelected = answers[qusId]?.selected || [];
    const updated = prevSelected.includes(optionId)
      ? prevSelected.filter((id) => id !== optionId)
      : [...prevSelected, optionId];
    setAnswers((prev) => ({
      ...prev,
      [qusId]: {
        selected: updated,
        otherText: prev[qusId]?.otherText || "",
      },
    }));
  };

  const handleSubmit = async () => {
    if (!templateData) return;

    const payload = {
      template_id: templateData.template_id,
      assessment_id: assessmentID,
      user_id: userId,
      status_id: 1,
      answers: [],
    };

    templateData.sections.forEach((section) => {
      section.questions.forEach((q) => {
        const category = getCategoryById(q.fb_qus_cat_id);
        const answer = answers[q.qus_id];
        if (!answer) return;

        if (category === "text") {
          payload.answers.push({ qus_id: q.qus_id, fb_ans_text: answer });
        } else if (category === "rating") {
          payload.answers.push({ qus_id: q.qus_id, fb_qus_ans_opt_id: answer });
        } else if (category === "choice_single" || category === "yes_no") {
          const selectedOption = questionOptions
            .find((o) => o.qus_id === q.qus_id)
            ?.answer_options.find(
              (opt) => opt.fb_qus_ans_opt_id === answer.selected,
            );

          if (
            selectedOption?.answer_option?.toLowerCase().includes("other") &&
            answer.otherText?.trim()
          ) {
            payload.answers.push({
              qus_id: q.qus_id,
              fb_qus_ans_opt_id: answer.selected,
              fb_ans_text: answer.otherText.trim(),
            });
          } else {
            payload.answers.push({
              qus_id: q.qus_id,
              fb_qus_ans_opt_id: answer.selected,
            });
          }
        } else if (category === "choice_multi") {
          (answer.selected || []).forEach((optId) => {
            const opt = questionOptions
              .find((o) => o.qus_id === q.qus_id)
              ?.answer_options.find((o) => o.fb_qus_ans_opt_id === optId);
            if (
              opt?.answer_option?.toLowerCase().includes("other") &&
              answer.otherText?.trim()
            ) {
              payload.answers.push({
                qus_id: q.qus_id,
                fb_qus_ans_opt_id: optId,
                fb_ans_text: answer.otherText.trim(),
              });
            } else {
              payload.answers.push({
                qus_id: q.qus_id,
                fb_qus_ans_opt_id: optId,
              });
            }
          });
        }
      });
    });

    setLoading(true);
    try {
      await saveFeedbackAnswer(payload);
      setThankyouPage(true);
      setShowFeedbackForm(false);
    } catch (error) {
      console.error("Error saving feedback:", error);
      alert("Failed to save feedback.");
    } finally {
      setLoading(false);
    }
  };

  if (!templateData) return null;

  return (
    <div style={{ height: "90vh", overflow: "auto" }}>
      <ContentWrapper>
        <Card>
          {!showFeedbackForm && !showThankyouPage && (
            <CardBody className="p-6">
              {/* Header */}
              <CardHeader className="mb-4">
                <CardTitle cardLabel="Assessment Report" />

                <div className="rounded-xl border border-green-200 bg-gradient-to-r from-green-50 to-green-100 p-5">
                  <h2 className="text-lg font-bold text-green-800 flex items-center gap-2">
                    🎓 Congratulations!
                  </h2>

                  <p className="mt-2 text-green-900">
                    You have successfully completed the
                    <span className="font-semibold text-green-700">
                      "{formData.assessment_title || assessmentID}".
                    </span>
                  </p>

                  <div className="mt-3 rounded-lg bg-white/70 p-3 text-sm text-gray-700">
                    Below is a summary of your exam performance.
                  </div>
                </div>
              </CardHeader>

              {/* Summary Table */}
              <div className="overflow-hidden rounded-lg border">
                <table className="w-full text-sm">
                  <tbody className="divide-y">
                    <tr>
                      <td className="summary-label">Assessment ID</td>
                      <td className="summary-value">{assessmentID || "N/A"}</td>
                    </tr>

                    <tr>
                      <td className="summary-label">Assessment Title</td>
                      <td className="summary-value">
                        {formData.assessment_title || "N/A"}
                      </td>
                    </tr>

                    <tr>
                      <td className="summary-label">Subject</td>
                      <td className="summary-value">
                        {formData.subject || "N/A"}
                      </td>
                    </tr>

                    <tr>
                      <td className="summary-label">Total Questions</td>
                      <td className="summary-value">
                        {questionCount ?? "N/A"}
                      </td>
                    </tr>

                    <tr>
                      <td className="summary-label">Answered Questions</td>
                      <td className="summary-value">
                        {answeredCount ?? "N/A"}
                      </td>
                    </tr>

                    <tr>
                      <td className="summary-label">Exam Start Time</td>
                      <td className="summary-value">
                        {examStartTime || "N/A"}
                      </td>
                    </tr>

                    <tr>
                      <td className="summary-label">Exam Finish Time</td>
                      <td className="summary-value">
                        {examFinishTime || "N/A"}
                      </td>
                    </tr>

                    <tr>
                      <td className="summary-label">Assigned Duration</td>
                      <td className="summary-value">
                        {formData.time_duration
                          ? `${formData.time_duration} min`
                          : "N/A"}
                      </td>
                    </tr>

                    <tr>
                      <td className="summary-label">Time Spent</td>
                      <td className="summary-value font-semibold">
                        {examStartTime &&examFinishTime
                          ? calculateDuration(
                              examStartTime,
                              examFinishTime,
                            )
                          : "N/A"}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Footer / CTA */}
              <div className="mt-5 rounded-xl border border-blue-200 bg-blue-50 p-4">
                <h3 className="font-semibold text-blue-800 flex items-center gap-2">
                  💡 Help us improve!
                </h3>

                <p className="mt-1 text-sm text-blue-700">
                  Please complete a short feedback form.
                  <span className="font-medium"> Your input is valuable.</span>
                </p>
              </div>

              <div className="mt-4 flex justify-end">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => setShowFeedbackForm(true)}
                >
                  Next
                </Button>
              </div>
            </CardBody>
          )}

          {showFeedbackForm && !showThankyouPage && (
            <CardBody>
              <div className="modal-title-custom">
                Student-Friendly Questionnaire
              </div>
              <div className="template-title">{templateData.title}</div>
              <div className="template-title2">{templateData.description}</div>
              <div className="template-title3">ASMNT{assessmentID}</div>
              <div className="template-title4">"{formData.assessment_title }"</div>

              {templateData.sections.map((section) => (
                <div key={section.fb_sec_id} className="feedback-section">
                  <h5 className="section-title">{section.title}</h5>
                  {section.allow_instruction && (
                    <p className="section-instruction">{section.instruction}</p>
                  )}

                  {section.questions.map((q) => {
                    const category = getCategoryById(q.fb_qus_cat_id);
                    const options =
                      questionOptions.find((opt) => opt.qus_id === q.qus_id)
                        ?.answer_options || [];

                    return (
                      <div key={q.qus_id} className="feedback-question">
                        <p className="question-content">{q.qus_content}</p>

                        {category === "text" && (
                          <TextField
                            fullWidth
                            variant="outlined"
                            value={answers[q.qus_id] || ""}
                            onChange={(e) =>
                              handleAnswerChange(q.qus_id, e.target.value)
                            }
                            placeholder="Type your answer here..."
                          />
                        )}

                        {category === "rating" && (
                          <Box className="rating-box">
                            <Rating
                              name={`rating-${q.qus_id}`}
                              value={answers[q.qus_id] || 0}
                              onChange={(event, newValue) =>
                                handleAnswerChange(q.qus_id, newValue)
                              }
                              precision={1}
                              emptyIcon={
                                <StarIcon
                                  style={{ opacity: 0.3 }}
                                  fontSize="inherit"
                                />
                              }
                            />
                          </Box>
                        )}

                        {(category === "choice_single" ||
                          category === "yes_no") && (
                          <div>
                            <RadioGroup
                              value={answers[q.qus_id]?.selected || ""}
                              onChange={(e) =>
                                handleAnswerChange(q.qus_id, {
                                  selected: parseInt(e.target.value),
                                  otherText: "",
                                })
                              }
                            >
                              {options.map((opt) => (
                                <FormControlLabel
                                  key={opt.fb_qus_ans_opt_id}
                                  value={opt.fb_qus_ans_opt_id}
                                  control={<Radio />}
                                  label={opt.answer_option}
                                />
                              ))}
                            </RadioGroup>

                            {answers[q.qus_id]?.selected &&
                              (() => {
                                const selectedOption = options
                                  .find(
                                    (opt) =>
                                      opt.fb_qus_ans_opt_id ===
                                      answers[q.qus_id]?.selected,
                                  )
                                  ?.answer_option?.trim()
                                  .toLowerCase();
                                return (
                                  selectedOption === "other" ||
                                  selectedOption?.includes("වෙනත්") ||
                                  selectedOption?.includes("பிற")
                                );
                              })() && (
                                <TextField
                                  sx={{ width: "60%", mt: 1 }}
                                  variant="outlined"
                                  placeholder="Please specify..."
                                  value={answers[q.qus_id]?.otherText || ""}
                                  onChange={(e) =>
                                    handleAnswerChange(q.qus_id, {
                                      ...answers[q.qus_id],
                                      otherText: e.target.value,
                                    })
                                  }
                                />
                              )}
                          </div>
                        )}

                        {category === "choice_multi" && (
                          <div className="checkbox-group">
                            {options.map((opt) => (
                              <FormControlLabel
                                key={opt.fb_qus_ans_opt_id}
                                control={
                                  <Checkbox
                                    checked={(
                                      answers[q.qus_id]?.selected || []
                                    ).includes(opt.fb_qus_ans_opt_id)}
                                    onChange={() =>
                                      handleCheckboxChange(
                                        q.qus_id,
                                        opt.fb_qus_ans_opt_id,
                                      )
                                    }
                                  />
                                }
                                label={opt.answer_option}
                              />
                            ))}

                            {(answers[q.qus_id]?.selected || []).map((id) => {
                              const option = options.find(
                                (o) => o.fb_qus_ans_opt_id === id,
                              );
                              if (!option) return null;

                              const isOther =
                                option.answer_option
                                  ?.trim()
                                  .toLowerCase()
                                  .includes("other") ||
                                option.answer_option
                                  ?.trim()
                                  .toLowerCase()
                                  .includes("වෙනත්") ||
                                option.answer_option
                                  ?.trim()
                                  .toLowerCase()
                                  .includes("பிற");
                              return isOther ? (
                                <TextField
                                  key={`other-${id}`}
                                  sx={{ width: "60%", mt: 1 }}
                                  variant="outlined"
                                  placeholder="Please specify..."
                                  value={answers[q.qus_id]?.otherText || ""}
                                  onChange={(e) =>
                                    handleAnswerChange(q.qus_id, {
                                      ...answers[q.qus_id],
                                      otherText: e.target.value,
                                    })
                                  }
                                />
                              ) : null;
                            })}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              ))}

              <Stack spacing={2} direction="row" mt={2}>
                <Button
                  variant="outlined"
                  onClick={() => setShowFeedbackForm(false)}
                  disabled={loading}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={handleSubmit}
                  disabled={loading}
                >
                  {loading ? <CircularProgress size={24} /> : "Submit Feedback"}
                </Button>
              </Stack>
            </CardBody>
          )}

          {!showFeedbackForm && showThankyouPage && (
            <div className="flex min-h-[60vh] items-center justify-center px-4">
              <div className="w-full max-w-md rounded-2xl border bg-white p-8 text-center shadow-sm">
                <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-green-100 text-3xl">
                  🎉
                </div>

                <h2 className="text-xl font-bold text-gray-900">Thank You!</h2>

                <p className="mt-2 text-sm text-gray-600">
                  You have successfully completed the assessment and submitted
                  your feedback.
                </p>

                <p className="mt-3 text-sm text-gray-700">
                  🌟 We truly appreciate your time and effort.
                  <br />
                  Best wishes for your results and future success!
                </p>

                <div className="mt-6 flex gap-3 justify-center">
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => history.goBack()}
                  >
                    Go to Dashboard
                  </Button>

                  <Button
                    variant="contained"
                    color="success"
                    onClick={() => onClose({ action: "success" })}
                  >
                    Continue
                  </Button>
                </div>
              </div>
            </div>
          )}
        </Card>
      </ContentWrapper>
    </div>
  );
}

export default FeedbackAssessment;
